import { render, staticRenderFns } from "./insureDetail.vue?vue&type=template&id=43dd9118&scoped=true"
import script from "./insureDetail.vue?vue&type=script&lang=js"
export * from "./insureDetail.vue?vue&type=script&lang=js"
import style0 from "./insureDetail.vue?vue&type=style&index=0&id=43dd9118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dd9118",
  null
  
)

export default component.exports